export function linkDynamicHTML(scope, html) {
    // Find all the 'ng-model="modelName"' directives in html, and use these
    // to set up watchers on scope, so that we can update the provided model with
    // changes in those values. This assumes scope has 'model' attribute to hold
    // the data.
    const modelDirectives = /ng-model=["']([a-zA-Z_]+)["']/g;
    let result = modelDirectives.exec(html);
    while (result !== null) {
        const modelName = result[1];
        scope.$watch(modelName, newValue => {
            scope.model[modelName] = newValue;
        });
        result = modelDirectives.exec(html);
    }
}


// WEBPACK FOOTER //
// ./src/directives/util.js